<div style="padding:20px"> 
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
            <span [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <div class="datebg">
        <div class="card text-white bg-light mb-3 info_item" style="margin-top:10px" >
            <div class="card-header" *ngIf="now=='1' || now == '3'">   
                <app-date [time]="time" [type]="true" [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"  (showDatePickered)="showDatePickered($event)"></app-date>
            </div>
            <div class="card-body" *ngIf="top_info && now == '1'">
                <div  class="card-text top_info_num">
                    推廣的人數：{{relation|number}}人
                </div>
                <div  class="card-text top_info_num">
                    抽成的獎金：{{earn_money|number}}元
                </div>
                <div  class="card-text top_info_num">
                    點擊次數：{{agent_link_click|number}}次
                </div>
                <div  class="card-text top_info_num">
                    代理推薦首儲
                    <input 
                        (change)="agent_point_update(44)" 
                        type="text" 
                        [(ngModel)]="agent_points" 
                        style="width: 160px;display:inline-block" 
                        class="form-control" 
                        placeholder="請輸入代理首儲"
                        pattern="^\d*\.?\d*$" 
                        title="請輸入數字或小數點" 
                        (keypress)="isNumberKey($event)"
                    />
                </div>
                <div  class="card-text top_info_num">
                    代理抽成
                    <input 
                        (change)="agent_point_update(45)" 
                        type="text" 
                        [(ngModel)]="agent_point2" 
                        style="width: 160px;display:inline-block" 
                        class="form-control" 
                        placeholder="請輸入代理抽成"
                        pattern="^\d*\.?\d*$" 
                        title="請輸入數字或小數點" 
                        (keypress)="isNumberKey($event)"
                    />
                </div>
            </div>
        </div>     
    </div>
    <div *ngIf="now=='1'">
        <input (keyup.enter)="init_list()" type="text" [(ngModel)]="tool_obj.search_model" style="width: 160px;display:inline-block" class="form-control" placeholder="請輸入姓名或手機">
        <button class="btn btn-primary"  (click)="init_list()">確認</button>
        <div style="margin-top: 4%;">
            <app-table-v2 [type]="1"  [data]="data"  [tcontent]="tcontent2"  *ngIf="data.length>0">
                <ng-template let-post #operation_dk>
                    <div *ngIf="post.key == 'subnember'"> 
                        <a href="javascript:void(0);"  (click)="defaultpage();get_agent_relation(post.val.agent_relation_val)"  data-toggle="modal" data-target="#exampleModal">
                            {{post.val.agent_relation}}
                        </a>
                    </div>
                </ng-template>
            </app-table-v2>
            <div *ngIf="data.length==0">無資料</div>

        </div>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">下線列表</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-table-v2 [type]="1"  [data]="agent_relation_item"  [tcontent]="tcontent3"></app-table-v2>
                <div *ngIf="agent_relation_item.length >0">
                    <app-pagnation (callback)="callback2($event)"  [data]="pageobjstr2"></app-pagnation> 
                </div>
            </div>
            

            <div class="modal-footer">
                <button type="button" class="btn btn-primary"  data-dismiss="modal">關閉</button>
            </div>
        </div>
    </div>
</div>

     
<app-spinner [loading]="loading"></app-spinner>